/* <pre-upsell-modal> custom element. Loaded synchronously by sections/pre-upsell.liquid in the same
   spot the inline script used to run, so callers that open the modal directly see the same timing. */
(function () {
  if (window.__bbePreUpsellElementDefined) return
  window.__bbePreUpsellElementDefined = true

  // Localized checkout URL (mirrors the cart-drawer's cart_checkout_url).
  // Read from the <pre-upsell-modal data-checkout-url> at runtime so that
  // liquid-ajax-cart's section re-renders don't get stuck with a stale
  // closure value.
  function getCheckoutUrl() {
    return document.querySelector('pre-upsell-modal')?.dataset.checkoutUrl
      || "/checkout"
  }

  // Helpers to apply/remove `inert` on background page chrome. The modal
  // and overlay render inside a `.shopify-section` wrapper (not direct body
  // children) — inert on that ancestor blocks every descendant, so we must
  // skip the section root that contains the upsell UI.
  function getPreUpsellSectionRoot() {
    const modal = document.querySelector('pre-upsell-modal')
    if (!modal) return null
    return (
      modal.closest('.shopify-section') ||
      modal.closest('[id^="shopify-section-"]') ||
      modal.parentElement
    )
  }

  function applyBackgroundInert() {
    const modal = document.querySelector('pre-upsell-modal')
    const overlay = document.querySelector('.pre-upsell__overlay')
    const sectionRoot = getPreUpsellSectionRoot()
    if (!modal) return
    ;[sectionRoot, modal, overlay].forEach((el) => {
      if (!el) return
      el.removeAttribute('inert')
      delete el.dataset.bbePreupsellInerted
    })
    Array.from(document.body.children).forEach((child) => {
      if (child === modal || child === overlay || child === sectionRoot) return
      if (child.contains(modal) || (overlay && child.contains(overlay))) return
      if (child.hasAttribute('inert')) return
      child.setAttribute('inert', '')
      child.dataset.bbePreupsellInerted = 'true'
    })
  }

  function clearBackgroundInert() {
    document.querySelectorAll('[data-bbe-preupsell-inerted="true"]').forEach((el) => {
      el.removeAttribute('inert')
      delete el.dataset.bbePreupsellInerted
    })
  }

  let preUpsellCheckoutPending = false

  function goToCheckoutAfterDismiss() {
    if (preUpsellCheckoutPending) return
    preUpsellCheckoutPending = true

    if (typeof window.recordCartStat === 'function') {
      window.recordCartStat('__cartPreupsell_dismissed')
    }

    const checkoutUrl = getCheckoutUrl() || '/checkout'
    window.location.assign(checkoutUrl)
  }

  const PRE_UPSELL_ADDED_LABEL = '✓ ADDED'
  // Keep in sync with PRE_UPSELL_ADD_SELECTOR in src/js/cart-drawer/cart-pre-upsell-gate.js.
  const PRE_UPSELL_ELIGIBLE_ADD_SELECTOR =
    '.pre-upsell__item:not(.added):not(.pre-upsell__item--market-hidden):not([hidden]) button[data-upsell-add]:not([disabled])'
  const PRE_UPSELL_COUNTDOWN_THRESHOLDS = [60, 30, 10, 5]

  /** App offers may use GIDs; cart lines use numeric variant_id. */
  function normalizePpupVariantId(id) {
    const s = String(id || '')
    const m = s.match(/(\d+)$/)
    return m ? m[1] : s
  }

  function buildPreUpsellRemoveUrl(lineKey) {
    if (!lineKey) return ''
    const root = window.Shopify?.routes?.root || '/'
    const base = root.endsWith('/') ? root : root + '/'
    return base + 'cart/change?id=' + encodeURIComponent(lineKey) + '&quantity=0'
  }

  function setPreUpsellAddedState(card, line) {
    if (!(card instanceof Element)) return
    const addState = card.querySelector('[data-pre-upsell-add-state]')
    const addedState = card.querySelector('[data-pre-upsell-added-state]')
    const addBtn = card.querySelector('button[data-upsell-add]')

    if (!line?.key) {
      resetPreUpsellCard(card)
      return
    }

    const removeUrl = line.url_to_remove || buildPreUpsellRemoveUrl(line.key)
    if (!removeUrl) {
      resetPreUpsellCard(card)
      return
    }

    card.classList.add('added')
    card.dataset.ppupLineKey = line.key

    if (addState) addState.hidden = false
    if (addedState) {
      addedState.hidden = true
      addedState.setAttribute('aria-hidden', 'true')
      const removeBtn = addedState.querySelector('[data-upsell-remove]')
      if (removeBtn instanceof HTMLAnchorElement) {
        removeBtn.href = removeUrl
        removeBtn.setAttribute('data-ajax-cart-request-button', removeUrl)
        removeBtn.dataset.lineKey = line.key
        removeBtn.dataset.id = line.key
      }
    }

    if (addBtn instanceof HTMLButtonElement) {
      addBtn.classList.remove('loading', 'bbe-cart-loading', 'bbe-cart-loading--on-dark')
      addBtn.removeAttribute('aria-busy')
      addBtn.classList.add('is-added')
      addBtn.disabled = false
      addBtn.removeAttribute('aria-disabled')
      addBtn.dataset.lineKey = line.key
      addBtn.dataset.removeUrl = removeUrl
      addBtn.setAttribute('aria-label', addBtn.dataset.removeAriaLabel || 'Remove item from cart')
      const btnText = addBtn.querySelector('.btn-text')
      if (btnText) btnText.textContent = PRE_UPSELL_ADDED_LABEL
    }
  }

  function resetPreUpsellCard(card) {
    if (!(card instanceof Element)) return
    card.classList.remove('added')
    delete card.dataset.ppupLineKey
    const addState = card.querySelector('[data-pre-upsell-add-state]')
    const addedState = card.querySelector('[data-pre-upsell-added-state]')
    if (addState) addState.hidden = false
    if (addedState) {
      addedState.hidden = true
      addedState.setAttribute('aria-hidden', 'true')
    }
    const addBtn = card.querySelector('button[data-upsell-add]')
    resetPreUpsellAddButton(addBtn)
  }

  function formatPpupMoney(cents) {
    const n = Math.round(Number(cents) || 0)
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(
          n,
          window.theme?.moneyFormat || window.money_format || '${{amount}}',
        )
      } catch {
        // fall through to manual format
      }
    }
    return '$' + (n / 100).toFixed(2)
  }

  function syncPpupCardFromSelect(sel) {
    const card = sel?.closest?.('.pre-upsell__item')
    if (!(card instanceof Element)) return
    const opt = sel.options?.[sel.selectedIndex]
    if (!opt || opt.disabled) return

    const variantId = String(opt.value || '')
    card.dataset.variantId = variantId

    const form = card.querySelector('form[action*="/cart/add"]')
    const variantInput = form?.querySelector('input[name="id"]')
    if (variantInput) variantInput.value = variantId

    const priceCents = parseInt(opt.getAttribute('data-price'), 10) || 0
    const compareCents = parseInt(opt.getAttribute('data-compare'), 10) || 0
    const netCents = opt.getAttribute('data-net-cents')
    const formWrap = card.querySelector('ajax-cart-product-form')
    if (formWrap instanceof Element) {
      if (netCents) {
        formWrap.dataset.bbeUpsellNetCents = netCents
      } else {
        delete formWrap.dataset.bbeUpsellNetCents
      }
    }

    const priceEl = card.querySelector('.pre-upsell__item-current-price')
    const compareEl = card.querySelector('.pre-upsell__item-compare_at')
    if (priceEl) priceEl.textContent = formatPpupMoney(priceCents)
    card.dataset.ppupPriceCents = String(priceCents)
    if (compareEl) {
      if (compareCents > priceCents) {
        compareEl.textContent = formatPpupMoney(compareCents)
        compareEl.hidden = false
        card.dataset.ppupCompareCents = String(compareCents)
      } else {
        compareEl.textContent = ''
        compareEl.hidden = true
        delete card.dataset.ppupCompareCents
      }
    } else if (compareCents > priceCents) {
      card.dataset.ppupCompareCents = String(compareCents)
    } else {
      delete card.dataset.ppupCompareCents
    }

    const cart = window.liquidAjaxCart?.cart
    const paidLine = (cart?.items || []).find((line) => {
      if (typeof window.bbeIsFreeCartLine === 'function' && window.bbeIsFreeCartLine(line)) {
        return false
      }
      return String(line.variant_id) === variantId
    })

    if (paidLine) {
      setPreUpsellAddedState(card, paidLine)
    } else if (card.classList.contains('added')) {
      resetPreUpsellCard(card)
    }
  }

  const PPUP_TANNER_ACCESSORY_RE =
    /\b(brush|kabuki|mitt|applicator|glove|sponge|buffer|blend(?:ing|er)?|remover)\b/i

  function ppupIsTannerAccessoryText(text) {
    return PPUP_TANNER_ACCESSORY_RE.test(String(text || '').toLowerCase())
  }

  function ppupIsTannerHandle(handle) {
    const h = String(handle || '').toLowerCase()
    return h.includes('self-tanner') || h.includes('self_tanner')
  }

  function ppupIsTannerProductType(type) {
    return String(type || '').toLowerCase().includes('tanner')
  }

  function ppupIsTannerCartItem(item) {
    if (!item) return false
    const text = `${item.handle || ''} ${item.product_title || item.title || ''}`
    if (ppupIsTannerAccessoryText(text)) return false
    if (ppupIsTannerProductType(item.product_type)) return true
    if (ppupIsTannerHandle(item.handle)) return true
    return false
  }

  function ppupIsTannerDomCard(card) {
    if (!(card instanceof Element)) return false
    const handle = card.getAttribute('data-product-handle') || ''
    const title = String(
      card.getAttribute('data-st11-title')
        || card.querySelector('.lp-modal-offer-card__title')?.textContent
        || '',
    ).toLowerCase()
    const text = `${handle} ${title}`
    if (ppupIsTannerAccessoryText(text)) return false
    if (card.getAttribute('data-is-tanner') === 'true') return true
    if (ppupIsTannerHandle(handle)) return true
    return title.includes('tanner')
  }

  function ppupNormalizeShade(value) {
    return String(value || '').trim().toLowerCase()
  }

  function ppupExtractShadeFromCartLine(line) {
    const variantTitle = String(line.variant_title || '').trim()
    if (!variantTitle || variantTitle === 'Default Title') return ''
    return ppupNormalizeShade(variantTitle.split(' / ')[0])
  }

  function ppupFindSelectOptionForShade(select, targetShade) {
    if (!(select instanceof HTMLSelectElement) || !targetShade) return null
    const normalized = ppupNormalizeShade(targetShade)
    for (let i = 0; i < select.options.length; i += 1) {
      const opt = select.options[i]
      if (opt.disabled) continue
      const primary = ppupNormalizeShade(
        opt.getAttribute('data-variant-label')
          || opt.textContent.split('—')[0].split(' - ')[0],
      )
      if (primary === normalized) return opt
    }
    for (let i = 0; i < select.options.length; i += 1) {
      const opt = select.options[i]
      if (opt.disabled) continue
      const full = ppupNormalizeShade(opt.textContent.split('—')[0])
      if (full === normalized || full.includes(normalized) || normalized.includes(full)) {
        return opt
      }
    }
    return null
  }

  function matchPpupTannerShadesFromCart(cart, root) {
    const modal = root instanceof Element ? root : document.querySelector('pre-upsell-modal')
    if (!modal || !cart?.items?.length) return

    const cartShades = []
    for (let i = 0; i < cart.items.length; i += 1) {
      const line = cart.items[i]
      if (!ppupIsTannerCartItem(line)) continue
      const shade = ppupExtractShadeFromCartLine(line)
      if (shade && !cartShades.includes(shade)) cartShades.push(shade)
    }
    if (!cartShades.length) return

    modal.querySelectorAll('.pre-upsell__item').forEach((card) => {
      if (!ppupIsTannerDomCard(card)) return
      const select = card.querySelector('[data-pre-upsell-variant-select]')
      if (!(select instanceof HTMLSelectElement)) return

      for (let j = 0; j < cartShades.length; j += 1) {
        const opt = ppupFindSelectOptionForShade(select, cartShades[j])
        if (!opt) continue
        if (String(select.value) === String(opt.value)) return
        select.value = opt.value
        syncPpupCardFromSelect(select)
        return
      }
    })
  }

  window.bbeBuildPreUpsellRemoveUrl = buildPreUpsellRemoveUrl
  window.bbeSetPreUpsellAddedState = setPreUpsellAddedState
  window.bbeResetPreUpsellCard = resetPreUpsellCard
  window.bbeMatchPpupTannerShadesFromCart = matchPpupTannerShadesFromCart

  function setPreUpsellAddedButton(btn) {
    const card = btn?.closest?.('.pre-upsell__item')
    if (card) {
      const cart = window.liquidAjaxCart?.cart
      const variantId = card.dataset.variantId || ''
      const paidLine = (cart?.items || []).find((line) => {
        if (window.bbeIsFreeCartLine?.(line)) return false
        if (variantId) return String(line.variant_id) === variantId
        const handle = card.dataset.productHandle || ''
        const productId = card.dataset.productId || ''
        return (
          (handle && String(line.handle) === handle) ||
          (productId && String(line.product_id) === productId)
        )
      })
      setPreUpsellAddedState(card, paidLine)
      return
    }
    if (!(btn instanceof HTMLButtonElement)) return
    btn.classList.remove('loading', 'bbe-cart-loading', 'bbe-cart-loading--on-dark')
    btn.removeAttribute('aria-busy')
    btn.classList.add('is-added')
    btn.disabled = false
    btn.removeAttribute('aria-disabled')
    const btnText = btn.querySelector('.btn-text')
    if (btnText) btnText.textContent = PRE_UPSELL_ADDED_LABEL
  }

  function resetPreUpsellAddButton(btn) {
    if (!(btn instanceof HTMLButtonElement)) return
    btn.disabled = false
    btn.removeAttribute('aria-disabled')
    btn.classList.remove('loading', 'bbe-cart-loading', 'bbe-cart-loading--on-dark', 'is-added')
    btn.removeAttribute('aria-busy')
    delete btn.dataset.lineKey
    delete btn.dataset.removeUrl
    if (btn.dataset.defaultAriaLabel) btn.setAttribute('aria-label', btn.dataset.defaultAriaLabel)
    else btn.removeAttribute('aria-label')
    const btnText = btn.querySelector('.btn-text')
    if (btnText) btnText.textContent = btn.dataset.defaultLabel || 'ADD'
  }

  function formatPreUpsellCountdownDisplay(remainingSeconds) {
    const safe = Math.max(0, Math.floor(remainingSeconds))
    const minutes = Math.floor(safe / 60)
    const seconds = safe % 60
    return String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0')
  }

  function formatPreUpsellCountdownAnnouncement(thresholdSeconds) {
    if (thresholdSeconds <= 0) return 'Offer expired'
    if (thresholdSeconds >= 60) {
      const minutes = Math.round(thresholdSeconds / 60)
      return minutes === 1 ? '1 minute remaining' : minutes + ' minutes remaining'
    }
    return thresholdSeconds === 1
      ? '1 second remaining'
      : thresholdSeconds + ' seconds remaining'
  }

  class PreUpsellModal extends HTMLElement {
    constructor() {
      // Parser-safe: do not query children here. liquid-ajax-cart re-renders
      // the inner content on every cart event, so we wire listeners with
      // delegation in connectedCallback instead of caching child refs.
      super()
    }

    connectedCallback() {
      if (this._bbeWired) return
      this._bbeWired = true

      this._invoker = null
      this._overlay = document.querySelector('.pre-upsell__overlay')
      this._bodyScrollLocked = false
      this._savedScrollY = 0
      this._countdownInterval = null
      this._countdownRemainingMs = 0
      this._countdownAnnounced = new Set()

      this._onDocClick = this._onDocClick.bind(this)
      this._onKeydown = this._onKeydown.bind(this)
      this._onCartRequestEnd = this._onCartRequestEnd.bind(this)
      this._onVariantChange = this._onVariantChange.bind(this)

      // Close X + overlay use document delegation
      // section re-rendering by liquid-ajax-cart doesn't strand listeners
      // on detached nodes.
      document.addEventListener('click', this._onDocClick)
      document.addEventListener('keydown', this._onKeydown)
      document.addEventListener('liquid-ajax-cart:request-end', this._onCartRequestEnd)
      this.addEventListener('change', this._onVariantChange)
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocClick)
      document.removeEventListener('keydown', this._onKeydown)
      document.removeEventListener('liquid-ajax-cart:request-end', this._onCartRequestEnd)
      this.removeEventListener('change', this._onVariantChange)
      this._stopCountdown(true)
      this._unlockBodyScroll()
      if (typeof removeTrapFocus === 'function') removeTrapFocus()
      this._bbeWired = false
    }

    _lockBodyScroll() {
      if (this._bodyScrollLocked) return
      this._bodyScrollLocked = true
      const scrollY = window.scrollY || window.pageYOffset || 0
      this._savedScrollY = scrollY
      const body = document.body
      body.style.position = 'fixed'
      body.style.top = '-' + scrollY + 'px'
      body.style.width = '100%'
      body.style.overflow = 'hidden'
      document.documentElement.classList.add('bbe-pre-upsell-open')
    }

    _unlockBodyScroll() {
      if (!this._bodyScrollLocked) return
      this._bodyScrollLocked = false
      const scrollY = this._savedScrollY || 0
      const body = document.body
      body.style.position = ''
      body.style.top = ''
      body.style.width = ''
      body.style.overflow = ''
      document.documentElement.classList.remove('bbe-pre-upsell-open')
      window.scrollTo(0, scrollY)
    }

    _getCountdownRoot() {
      return this.querySelector('[data-pre-upsell-countdown]')
    }

    _resetCountdownDisplay() {
      const root = this._getCountdownRoot()
      if (!root) return
      const minutes = Number(root.dataset.countdownMinutes)
      const display = root.querySelector('[data-countdown-display]')
      const announcer = root.querySelector('[data-countdown-announcer]')
      if (!Number.isFinite(minutes) || minutes <= 0) return
      if (display) {
        display.textContent = String(minutes).padStart(2, '0') + ':00'
        display.classList.remove('is-expired')
      }
      root.classList.remove('is-expired')
      if (announcer) announcer.textContent = ''
    }

    _stopCountdown(reset) {
      if (this._countdownInterval) {
        window.clearInterval(this._countdownInterval)
        this._countdownInterval = null
      }
      this._countdownRemainingMs = 0
      this._countdownAnnounced = new Set()
      if (reset) this._resetCountdownDisplay()
    }

    _startCountdown() {
      const root = this._getCountdownRoot()
      if (!root) return

      this._stopCountdown(true)

      const minutes = Number(root.dataset.countdownMinutes)
      if (!Number.isFinite(minutes) || minutes <= 0) return

      const display = root.querySelector('[data-countdown-display]')
      const announcer = root.querySelector('[data-countdown-announcer]')
      const durationMs = minutes * 60 * 1000
      const startedAt = Date.now()
      this._countdownAnnounced = new Set()

      const tick = () => {
        const remainingMs = startedAt + durationMs - Date.now()

        if (remainingMs <= 0) {
          if (display) {
            display.textContent = '00:00'
            display.classList.add('is-expired')
          }
          root.classList.add('is-expired')
          if (announcer) announcer.textContent = 'Offer expired'
          this._stopCountdown(false)
          return
        }

        if (display) {
          display.textContent = formatPreUpsellCountdownDisplay(remainingMs / 1000)
        }

        if (announcer) {
          const remainingSeconds = Math.ceil(remainingMs / 1000)
          for (let i = 0; i < PRE_UPSELL_COUNTDOWN_THRESHOLDS.length; i += 1) {
            const threshold = PRE_UPSELL_COUNTDOWN_THRESHOLDS[i]
            if (!this._countdownAnnounced.has(threshold) && remainingSeconds <= threshold) {
              this._countdownAnnounced.add(threshold)
              announcer.textContent = formatPreUpsellCountdownAnnouncement(threshold)
              break
            }
          }
        }
      }

      tick()
      this._countdownInterval = window.setInterval(tick, 1000)
    }

    _activateFocusTrap() {
      if (typeof trapFocus !== 'function') return
      const focusTarget =
        this.querySelector('.pre-upsell__close')
        || this.querySelector('button[data-upsell-add]:not([disabled])')
        || this.querySelector('.pre-upsell__footer-button')
      try {
        trapFocus(this, focusTarget || this)
      } catch {
        // trapFocus throws when no focusable children exist.
      }
    }

    _hasPaidAdded() {
      return !!this.querySelector('[data-pre-upsell-paid-grid] .pre-upsell__item.added')
    }

    _updateProgressBar(options) {
      const opts = options || {}
      const goingToCheckout = opts.checkout === true
      const hasPaidAdded = this._hasPaidAdded()
      const step1 = this.querySelector('[data-pre-upsell-progress-step="1"]')
      const step2 = this.querySelector('[data-pre-upsell-progress-step="2"]')
      const line = this.querySelector('[data-pre-upsell-progress-line]')

      if (step1) {
        step1.classList.toggle('is-active', !goingToCheckout)
        // Complete (checkmark) only after leaving step 1 — not when an item is added.
        step1.classList.toggle('is-complete', goingToCheckout)
      }
      if (step2) {
        step2.classList.toggle('is-active', goingToCheckout)
        step2.classList.toggle('is-complete', false)
      }
      if (line) {
        line.classList.remove('is-half', 'is-full')
        line.removeAttribute('data-fill-step')
        if (goingToCheckout) {
          line.classList.add('is-full')
          line.dataset.fillStep = '2'
        } else if (hasPaidAdded) {
          line.classList.add('is-half')
          line.dataset.fillStep = '1'
        }
      }
    }

    _onDocClick(event) {
      const target = event.target
      if (!(target instanceof Element)) return
      if (!this.classList.contains('show')) return

      if (target.closest('[data-upsell-checkout]')) {
        // Navigate via JS rather than relying on the anchor's default href.
        // The default action is suppressed in the theme editor (design mode)
        // and by some delegated click handlers, which made the button appear
        // to do nothing. close() already navigates this way on dismiss.
        event.preventDefault()
        const checkoutUrl = getCheckoutUrl() || '/checkout'
        window.location.assign(checkoutUrl)
        return
      }

      if (target.closest('.pre-upsell__close')) {
        event.preventDefault()
        this.close()
        return
      }

      if (this._overlay && (target === this._overlay || target.closest('.pre-upsell__overlay'))) {
        event.preventDefault()
        if (this._closePreviewIfOpen()) return
        this.close()
      }
    }

    // The list layout's "Learn more" panel sits on top of the dialog; Escape
    // and overlay clicks close that panel first, not the whole popup.
    _closePreviewIfOpen() {
      if (!this.querySelector('[data-ppup-preview]:not([hidden])')) return false
      if (typeof window.bbeClosePpupPreview === 'function') window.bbeClosePpupPreview()
      return true
    }

    _onKeydown(event) {
      if (event.key !== 'Escape') return
      if (!this.classList.contains('show')) return
      event.preventDefault()
      if (this._closePreviewIfOpen()) return
      this.close()
    }

    _onVariantChange(event) {
      const sel = event.target?.closest?.('[data-pre-upsell-variant-select]')
      if (!(sel instanceof HTMLSelectElement) || !this.contains(sel)) return
      syncPpupCardFromSelect(sel)
      this._updateDynamicSavings()
      this._updateProgressBar()
    }

    // When liquid-ajax-cart resolves an add/change from the modal, keep
    // cards in the grid and mark them `.added` (never hide like LTO).
    // Re-sync from cart after section re-render so detached initiators
    // don't leave cards without the overlay.
    _isFreeCartLine(line) {
      if (typeof window.bbeIsFreeCartLine === 'function') {
        return window.bbeIsFreeCartLine(line)
      }
      const props =
        line?.properties && typeof line.properties === 'object' ? line.properties : {}
      if (props.__isFreebie === 'yes') return true
      const finalLinePrice = Number(line?.final_line_price ?? line?.line_price)
      if (Number.isFinite(finalLinePrice) && finalLinePrice <= 0) return true
      const finalUnitPrice = Number(line?.final_price ?? line?.price)
      return Number.isFinite(finalUnitPrice) && finalUnitPrice <= 0
    }

    _matchingCartLines(cart, card) {
      const handle = card.dataset.productHandle || ''
      const productId = card.dataset.productId || ''
      return (cart.items || []).filter((line) => {
        if (handle && String(line.handle) === handle) return true
        if (productId && String(line.product_id) === productId) return true
        return false
      })
    }

    _syncAddedCardsFromCart(cart) {
      const items = cart?.items || []
      if (!items.length) {
        this.querySelectorAll('.pre-upsell__item').forEach((card) => resetPreUpsellCard(card))
        this._updateDynamicSavings()
        this._updateProgressBar()
        return
      }

      matchPpupTannerShadesFromCart(cart, this)

      this.querySelectorAll('.pre-upsell__item').forEach((card) => {
        // An add still in flight: its line isn't in this snapshot yet, and a reset
        // would re-enable ADD mid-request (double add).
        if (card.querySelector('button[data-upsell-add][aria-busy="true"]')) return
        const variantId = normalizePpupVariantId(card.dataset.variantId || '')
        const matching = this._matchingCartLines(cart, card)
        const scoped =
          variantId && matching.length
            ? matching.filter((line) => String(line.variant_id) === variantId)
            : matching
        const linesToCheck = scoped.length ? scoped : matching

        if (linesToCheck.length && linesToCheck.every((line) => this._isFreeCartLine(line))) {
          card.hidden = true
          card.setAttribute('aria-hidden', 'true')
          card.classList.remove('added')
          return
        }

        card.hidden = false
        card.removeAttribute('aria-hidden')

        const handle = card.dataset.productHandle || ''
        const productId = card.dataset.productId || ''
        const isPaidInCart = (cart.items || []).some((line) => {
          if (this._isFreeCartLine(line)) return false
          if (variantId) {
            return String(line.variant_id) === variantId
          }
          return (
            (handle && String(line.handle) === handle) ||
            (productId && String(line.product_id) === productId)
          )
        })

        if (!isPaidInCart) {
          resetPreUpsellCard(card)
          return
        }

        const paidLine =
          linesToCheck.find((line) => !this._isFreeCartLine(line)) ||
          matching.find((line) => !this._isFreeCartLine(line))
        setPreUpsellAddedState(card, paidLine)
      })

      this._updateDynamicSavings()
      this._updateProgressBar()
      if (typeof window.bbeSyncPpupFreeCardLimits === 'function') {
        window.bbeSyncPpupFreeCardLimits(this)
      }
      if (typeof window.bbeSyncPpupGridColumns === 'function') {
        window.bbeSyncPpupGridColumns(this)
      }
    }

    _onCartRequestEnd(event) {
      const requestState = event?.detail?.requestState
      if (!requestState) return
      if (requestState.requestType !== 'add' && requestState.requestType !== 'change') return
      if (!this.classList.contains('show')) return

      const cart =
        event?.detail?.cart ||
        requestState.responseData?.body ||
        window.liquidAjaxCart?.cart

      if (requestState.responseData?.ok && cart?.items) {
        // Defer one frame so liquid-ajax-cart section HTML is in the DOM.
        requestAnimationFrame(() => {
          if (!this.classList.contains('show')) return
          this._syncAddedCardsFromCart(cart)

          // The LAC re-render dropped the client-applied market filter;
          // restore it so SKUs not purchasable in this market stay hidden
          // (F-04). Returns whether any add row is still eligible.
          var stillEligible = true
          if (typeof window.bbeReapplyPreUpsellMarketFilter === 'function') {
            stillEligible = window.bbeReapplyPreUpsellMarketFilter(this)
          }

          // If the shopper just added the last market-eligible upsell, there
          // is nothing left to offer — route straight to checkout rather
          // than leave an empty modal open.
          // Only an offer-card add counts, and never while the List popup gift
          // is waiting to be claimed (that add may be what unlocked it).
          const offerAdd = Boolean(requestState.info?.initiator?.closest?.('.pre-upsell__item'))
          const giftPending =
            typeof window.bbePpupGiftPending === 'function' && window.bbePpupGiftPending(cart)
          if (!stillEligible &&
              offerAdd &&
              !giftPending &&
              requestState.requestType === 'add' &&
              typeof window.bbeSkipPreUpsellToCheckout === 'function') {
            window.bbeSkipPreUpsellToCheckout(this.dataset.checkoutUrl || '/checkout')
          }
        })
      }

      const initiator = requestState.info?.initiator
      if (!(initiator instanceof Element)) return

      const card = initiator.closest('.pre-upsell__item')
      if (!card || !this.contains(card)) return

      if (initiator.closest('[data-upsell-remove]')) {
        const removeBtn = initiator.closest('[data-upsell-remove]')
        if (!requestState.responseData?.ok) {
          if (removeBtn instanceof HTMLElement && typeof window.bbeSetCartAtcLoading === 'function') {
            window.bbeSetCartAtcLoading(removeBtn, false)
          }
          return
        }
        const removeCard = removeBtn?.closest?.('.pre-upsell__item')
        if (removeCard instanceof Element) {
          resetPreUpsellCard(removeCard)
        }
        this._updateDynamicSavings()
        this._updateProgressBar()
        return
      }

      const btn = card.querySelector('button[data-upsell-add]')
      const wrapper = initiator.closest?.('ajax-cart-product-form') || initiator

      if (!requestState.responseData?.ok) {
        if (wrapper instanceof Element) wrapper.removeAttribute('processing')
        if (btn instanceof HTMLButtonElement) {
          btn.classList.remove('loading', 'bbe-cart-loading', 'bbe-cart-loading--on-dark')
          btn.removeAttribute('aria-busy')
          btn.disabled = false
        }
        return
      }

      // Confirm the variant we tried to add is reflected in the response
      // body. This guards against accidentally marking the wrong card on
      // multi-add bursts.
      const form = initiator.querySelector?.('form') || initiator.closest?.('form')
      const variantInput = form?.querySelector?.('input[name="id"]')
      const intendedVariantId = variantInput ? String(variantInput.value).trim() : ''
      const respItems = requestState.responseData?.body?.items || []
      if (intendedVariantId && respItems.length) {
        const matched = respItems.some(
          (line) => String(line.variant_id) === intendedVariantId,
        )
        if (!matched) return
      }

      card.classList.add('added')
      const cartSnapshot =
        event?.detail?.cart ||
        requestState.responseData?.body ||
        window.liquidAjaxCart?.cart
      const variantId = intendedVariantId || card.dataset.variantId || ''
      const paidLine = (cartSnapshot?.items || []).find((line) => {
        if (this._isFreeCartLine(line)) return false
        if (variantId) return String(line.variant_id) === variantId
        return false
      })
      setPreUpsellAddedState(card, paidLine)

      this._updateDynamicSavings()
      this._updateProgressBar()
    }

    _updateDynamicSavings(opts = {}) {
      if (typeof window.bbeUpdatePpupSavings === 'function') {
        window.bbeUpdatePpupSavings({ ...opts, root: this })
      }
    }

    open(invoker) {
      if (this.classList.contains('show')) return

      // Direct callers (LP add-to-cart flows, legacy hooks) may skip the
      // dynamic preparer, so both no-popup outcomes are enforced here too.
      if (document.querySelector('[data-bbe-ppup-page][data-ppup-layout="off"]')) {
        if (typeof window.bbeReportPpupPageOff === 'function') window.bbeReportPpupPageOff()
        window.location.assign(getCheckoutUrl() || '/checkout')
        return
      }
      if (!this.querySelector(PRE_UPSELL_ELIGIBLE_ADD_SELECTOR)) {
        if (typeof window.bbeSkipPreUpsellToCheckout === 'function') {
          window.bbeSkipPreUpsellToCheckout(getCheckoutUrl() || '/checkout')
        } else {
          window.location.assign(getCheckoutUrl() || '/checkout')
        }
        return
      }

      this._invoker = invoker || document.activeElement || null
      this._updateProgressBar()
      this.classList.add('show')
      if (this._overlay) this._overlay.classList.add('show')
      applyBackgroundInert()
      this._lockBodyScroll()
      this._startCountdown()

      // Modal view only — adds use __cartUpsellAddPreupsell (separate stat).
      if (typeof window.recordCartStat === "function") {
        window.recordCartStat("__cartPreupsell")
      }

      requestAnimationFrame(() => {
        this._activateFocusTrap()
        const cart = window.liquidAjaxCart?.cart
        if (cart?.items) this._syncAddedCardsFromCart(cart)
        // Center the card row by the count of *visible* offers (static
        // fallbacks are display:none'd but stay in the DOM, so :nth-child
        // counting is unreliable — pre-upsell.js drives an explicit count).
        if (typeof window.bbeSyncPpupGridColumns === 'function') {
          window.bbeSyncPpupGridColumns(this)
        }
      })
    }

    close() {
      if (!this.classList.contains('show') && !this.classList.contains('fading')) {
        return
      }

      // Navigate immediately on dismiss (X / overlay / Esc) — do not wait
      // for the fade-out animation or focus restore, which could leave the
      // shopper on the storefront if animationend never fires.
      goToCheckoutAfterDismiss()

      this._stopCountdown(true)
      this.classList.add('fading')
      if (this._overlay) this._overlay.classList.remove('show')

      const finishClose = () => {
        this.classList.remove('show', 'fading')
        clearBackgroundInert()
        this._unlockBodyScroll()
        this._invoker = null
        if (typeof removeTrapFocus === 'function') removeTrapFocus()
      }

      // Best-effort UI cleanup while navigation is in flight.
      let settled = false
      const safetyId = window.setTimeout(() => {
        if (settled) return
        settled = true
        finishClose()
      }, 320)

      this.addEventListener(
        'animationend',
        (event) => {
          if (event.target !== this || event.animationName !== 'animateFadeOut') return
          if (settled) return
          settled = true
          window.clearTimeout(safetyId)
          finishClose()
        },
        { once: true },
      )
    }
  }

  if (!customElements.get('pre-upsell-modal')) {
    customElements.define('pre-upsell-modal', PreUpsellModal)
  }
})()

// Backwards-compat init guard — once the custom element is defined, we
// don't actually need this, but keeping the gate prevents anyone re-adding
// the legacy wiring from double-binding.
function initPreUpsell() {
  if (window.__bbePreUpsellInit) return
  window.__bbePreUpsellInit = true
}

if (document.readyState !== 'loading') {
  initPreUpsell()
} else {
  document.addEventListener('DOMContentLoaded', initPreUpsell)
}
